export default __webpack_public_path__ + "static/media/stoxkart_old_logo.b15d68cb.png";